import React, {Component} from "react";
import "./CmTable.css";
import {Table, Pagination} from "antd";
import {Scrollbars} from "react-custom-scrollbars";

export default class CmTable extends Component {

    render() {
        const {
            columns,
            ToolBar,
            tableData: data,
            current,
            pageSize,
            onShowSizeChange,
            onChange,
            count,
            tableIsLoading,
            showRowSelection,
            showPagination = true,
            isParamsConfig
        } = this.props;
        // 是否展示 第一列选择
        let rowSelection = undefined;
        if (showRowSelection) {
            rowSelection = this.props.rowSelection;
        }

        return (
            <>
                <div id="CmTable">
                    <div className="cm-table-tool">
                        {ToolBar}
                    </div>
                    <div className="cm-table-body">
                        <Scrollbars className="cm-scrollbars" autoHide autoHeight autoHeightMax={"100vh - 233px"}>
                            <Table
                                columns={columns}
                                dataSource={data}
                                pagination={false}
                                rowClassName="cm-table-body-row"
                                rowKey="id"
                                loading={tableIsLoading}
                                rowSelection={rowSelection}
                            />
                        </Scrollbars>
                    </div>
                    {
                        data && data.length ? <div className="cm-table-pagination">
                            {
                                showPagination && count ?
                                    <Pagination
                                        current={current}
                                        total={count}
                                        showSizeChanger
                                        showQuickJumper
                                        pageSize={pageSize}
                                        pageSizeOptions={["10", "20", "30", "40"]}
                                        onShowSizeChange={onShowSizeChange}
                                        onChange={onChange}
                                        showTotal={total => `共 ${total} 条`}
                                    /> : null
                            }
                        </div> : null
                    }
                </div>
                <style>{`
                #CmTable .ant-table-placeholder {
                    height: 600px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-bottom:none;
                }
                `}</style>
            </>
        );
    }
}
